import React from "react";
import { generateGooutLink } from "../helpers/linkGenerators";
const defaultRedirectPathFn = (city) => generateGooutLink(city);
const CitySelectorContext = React.createContext({
    redirectPathFn: defaultRedirectPathFn,
    source_page: "home_page"
});
export default CitySelectorContext;
